import moment from 'moment';

export default class ReviewsRankingController {

    constructor (
        $filter,
        $state,
        $window,
        $timeout,
        SummaryRanking,
        brand,
		stores,
		selectedStore,
        endDate,
        startDate,
        storesInfoLoader,
        storesInfo
    ) {
        this.translate        = $filter('translate');
        this.$state           = $state;
        this.$window          = $window;
        this.$timeout         = $timeout;
        this.SummaryRanking   = SummaryRanking;
        this.brand            = brand;
        this.stores           = stores;
        this.selectedStore    = selectedStore;
        this.endDate          = endDate;
        this.startDate        = startDate;
        this.storesInfoLoader = storesInfoLoader;
        this.storesInfo       = storesInfo;

        this.headers = [
            { key: 'name', label: this.translate('NAME'), type: 'text' },
            { key: 'sentEmails', label: this.translate('EMAILCOUNT'), type: 'text' },
            { key: 'dematPercentage', label: this.translate('DEMAT_PERCENTAGE'), type: 'percentage' },
            { key: 'takenEmails', label: this.translate('TAKEN_EMAILS'), type: 'text' }
        ];

        this.hasRevenue = !!this.storesInfo.filter(elem =>  elem.revenue > 0).length;

        if (this.hasRevenue) {
            this.headers.push({ key: 'revenue', label:this.translate('REVENUE'), type: 'currency' });
        }

        this.storesInfo = this.formatStoreInfoForCustomTable(this.storesInfo);

	}

	formatStoreInfoForCustomTable(storesInfoArray) {

	    if(!storesInfoArray){
	        return [];
	    }

		return storesInfoArray
		    .filter(elt => elt.sentEmails || elt.revenue)
		    .map(elt => ({
		        ...elt,
		        npsValue: elt.npsValue && this.getNpsScoreDoughnutConfig(elt.npsValue)
		    }));

	}

}

ReviewsRankingController.$inject = [
    '$filter',
    '$state',
    '$window',
    '$timeout',
    'SummaryRanking',
    'brand',
	'stores',
	'selectedStore',
    'endDate',
    'startDate',
    'storesInfoLoader',
    'storesInfo'
];



// WEBPACK FOOTER //
// ./src/page/summaryRanking/summaryRanking.controller.js